// Stub for react-native-reanimated on web
// This module is optional and not needed for web builds
module.exports = {};

